import Api from "../constants/Api";
import HttpRequest from "./HttpRequest";

export const unsubscribeBulkEmail = async (body) => {
    return HttpRequest.post(Api.unsubscribeBulkEmail, body);
}